import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from '@/components/ui/sidebar.tsx';
import { LayoutSidebarApp } from '@/components/layout/layout-sidebar';
import { Helmet } from 'react-helmet-async';

export const DefaultLayout: FC = () => {
  return (
    <div className="flex items-stretch min-h-screen w-full">
      <Helmet>
        <title>Agro Monitoring</title>
      </Helmet>
      <SidebarProvider>
        <LayoutSidebarApp />
        <main className="overflow-hidden w-full">
          <Outlet />
        </main>
      </SidebarProvider>
    </div>
  );
};
